// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1A1p_","productName":"Table_productName__1xcR6"};